var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFinlandMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 74 129"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__a)",
  d: "m18.204 12.694.924-.904 1.302 1.01.208-.724-.405-1.07.69-.824 1.028-.506 1.65.574 2.794 5.668-.081 1.374.706-.298 1.224.887 1.28.133.276.573 1.164-.525 1.099-.389.44-.777.832-.437 1.644 1.22 1.74.762.964 1.186.246-.503.688.004-.112-1.427 1.003-1.477.736-.443.811.208.398-1.397-.147-2.482.73-4.18.375-.683-.22-.637.573-.92 1.165-1.038.69-1.646 1.133-.397 1.97.514 1.705-1.354.427-.62.615.2.622-.393 1.104 1.54 1.066.67.08.757 3.482 1.716 1.168 2.983-2.068 2.69-.14 1.346.411 1.442-2.15 1.811 1.307-.004.325.55-.259 1.855-1.148 2.073.976 4.072 2.884 1.174 1.886 3.853 1.84 1.379-.148 1.798-3.913 7.346-.298.98 2.572 4.346 1.224 3.292.988 1.457 1.177 3.362.348 2.443-.765.072-1.126.75.426.706-.353 1.19-.086 1.293-.436 1.476 1.042.096.325.376-.34.699.278.37-.303.628-.767.256-.214.802.592 2.278 2.01.413-.177.637.422.529-.026.8-.439.385.004.907.616 1.66 2.158 1.48.422 1.965-1.362 3.557-1.286.918 2.174 2.324.72 1.017 1.786.813 1.266 1 .995.687.462 1.592L73.22 88.7l.483 1.222-1.656 5.26-1.4 2.607-.754.295-1.145 1.759-1.592 2.792-.85.881-.476 1.349-1.197 1.103-.805 1.691-1.015.719-.229.709-1.505 2.541-1.763 1.224-.63.257-.757 1.297-.096.851-.814.181-1.526 1.337-.293.783-2.146 2.066-.02.405-.412.273-.481-.315-.192.147-.15.672-.211.347-.32.01-.389.056-.254-.141-.233.157-.282.265-.36-.536-.937-.11-1.136-.371-.46.462.014.742-.166.297-.465-.014-.534-.534-.312.285-.4.014-.25-.264-.264.183-.562.001-.642.632-.298-.011-.207-.448-.396.023.044.584-.209.337-.241.019-.205-.457-.434-.447-.62-.592-.053.324.38.513.104.42.373.662-.223.097-.303-.15-.197.068.038.5-.204.081-.333-.687-.167.136.186.596-.17.219-.327-.204-.296.319-.2-.037-.503-.627-.158-.584-.635.072-.014.53-.245.301-.967.025-.77.212-.09.278-.309.42-.43-.134.067.501-.431.365-.085-.465-.19.301-.563-.008-.401-.273-1.068.375-.208-.208-.085.204.001.395-1.171 1.473-.38-.029.517-.678-.24-.139-.277.241-.189-.002.037-.765-.88.487-1.207.027-1.463.627-.723.067.102.372-.257.196-.5-.108-.637.136-.31-.222-.483-.062-.396.439v.287l-.516.442-1-.008-.826.343-.276-.349.258-.291 1.103-.389.224-.27.103-.77-.19-.295-.224.181-.017.632-.189.184-.707-.123-.388-.513.096-.469.448-.02.361.187.188-1.596-.633-.381-.159-.842 1.172-1.429-.223-.371-1.413 1.093-.914.27-.393-.356-.626.016-.001-.385.587-.939-.358-.272-.223.193-1.503.29-.395-.375-.32-.02.067-.838-.14-.109-.352.227-.435-.397.128-.159.297.015.016-.316-.32-.309-.849.026-.663.162.03-.318.29-.408.315.031.275-.71-.27-.121-.804.432-.198.857-.445.04-.173-.744-.57-.501-.438-1.15.013-.717-.203-.323-.021-.524-.097-.365.073-.216.129-.088.062-.201-.605-.368-.034-.225.53-.107.018-.312-.258-.277.152-.16.292-.019.257.517.272.216.09-.308-.436-.453-.173-.95.33-.184.181.278.277-.557.293-1.673.3.201.153-.194-.032-.263.188-.974-.409-.96.077-.121.188-.061.28.11.215-.04-.145-.354-.448-.237-.034-.316.301.012.476.14-.014-.179-.262-.213-.282-.572.119-.226.222.015.355.405.265.009-.514-1.157v-1.049l-.535-.693.108-.237.313-.033.02-.186-.24-.187-.148-.942-.356-.218-.108-.401-.312-.519.288-1.093.307-.504-.018-.449.474-.507-.062-.323-.596-.232-.001-.45.406-.541.025-.283-.864-.043-.258-.399.24-.95-.185-.196.088-.744.394-.645-.04-.26-.207-.154-.27.228-.153-.184.129-.82.195-.23.255-.231.038-.347-.267-.304.048-.192.45.023.228-.243.118-.721.438-.151.028.22.449-.051.17-.175-.052-.414.418-.397.042-.469-.178-.383-.417-.319.185-.3.397.263.252-.082.364.097.205-.08-.125-.309-.394-.344-.05-.313.335-.416.03-.866.321-.325.193.577.458-.01.981-.414 1.38.495.516-.121.323-.614.441-.009.177-.428-.482-1.083-.22-.22-.095-.31.158-.209.303-.018.198-.856.272-.15.261.344.15-.66.358-.26.04-.195.383-.33.266-.115.073-.346.481-.307.062-.47-.11-.644.394-.26.388-.58.52.002.239.288.263-.006.233-.342 1.908-.086.042-1.826.318-.228.472.45.379-.065.048-.938.688-1.05.296-.239.358-.541.3.198.243-.131.01-.587.306-.503.12-.286.807-.866.695-.46.035-.28.504-.389.406-1.718.763-.53.204-1.058.493-.057.169-.306.285-.255.855-.008.378-.295.73.006.781.455.071.418.358.031.205-.186-.157-.47-.779-.782-.046-.34.094-.267.534.046.574.465.256.012.03-.227-.375-.383-.125-.828-.21-.387-.496-.285-.174-.382.346-.465.004-1.243-.217-.4.25-.308v-.583l.325-.346.04-.496-.744-1.327-.186.171-.277-.001-.023-.522-.335-.343-.354.033-.33-.428-.556-.083-.278.228-.33.033-.156-.507-.405.265-.211-.245.293-.615-.26-.385-.834-.31-.386-.463-.309.493-.442.05-.01-.876-.405-1.092-.06-.789-.669-1.094-.043-.822-.805-.781-.313-1.555.184-.477-.166-.668.239-.74.189-.617.705-.613.136-2.244.698-.772-1.895-4.383.044-1.256.946-.492-.212-.73.28-.633-1.1-.19-.463-.835.6-1.547-.047-2.264.016-.737.347-.585.44-.523-1.055-1.098-.24-1.138-.572.08-.247-.678-.003-1.154-1.877-1.73-1.728-.794-1.298-.296-.36-1.04-.885-.434-.348-.875-.948-.294-1.3-2.7-.906-.245-.07-1.05z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__b)",
  d: "m34.49 64.272.24-.45 1.327-.31.37.438.366-.006.234-.12.205.187-.009.24-.489.2-.495-.328-.395.106.284.905-.348.25-.423-.263-.454.117z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__c)",
  d: "m37.71 63.254.348.132.049.333h-.276l-.258-.224z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__d)",
  d: "m29.064 74.156.072.253-.176.317-.293.017.086-.466z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__e)",
  d: "m23.293 78.918-.047.557-.246.253-.19-.379.208-.673z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__f)",
  d: "m18.66 83.075-.013.333-.314.082-.19-.467.362-.103z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__g)",
  d: "m19.762 83.99.222.208-.134.225-.394.02-.262.202-.19-.017.396-.638z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__h)",
  d: "m20.537 84.783.033.398-.22.415-.532-.256-.452.013-.155-.346.517-.327.552.234z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__i)",
  d: "m17.592 84.645.48.415-.082.26-.29-.273-.194.426-.224-.052v-.414z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__j)",
  d: "m14.991 83.54.222.002.006.383-.245.375h-.328l.138-.362z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__k)",
  d: "m15.646 83.886.29.001.144.332-.245.323h-.413l-.19-.328z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__l)",
  d: "m15.18 84.731.007.28-.247.238.13.227.405.013.155-.331.334.09.272.592-.164.427-.448-.158-.256.4-.356-.082-.245-.23-.276-.017-.378-1.449.258-.086.206.232.36-.361z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__m)",
  d: "m12.476 88.13.257.105-.012.296-.107.22h-.241l-.138-.259z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__n)",
  d: "m14.336 88.165.27.22.039.298-.08.366-.229-.005-.223-.19v-.552z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__o)",
  d: "m13.871 90.183.36-.172.161.35-.228.167-.207.172-.292-.172z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__p)",
  d: "m13.32 91.442.153-.033.23.47-.073.115-.258.017-.086-.172z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__q)",
  d: "m13.25 93.651.264.297.013.168-.276.155-.206-.207.084-.242z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__r)",
  d: "m13.456 110.592.234.146.06.284-.154.207-.224.017-.105-.397.057-.111z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__s)",
  d: "m11.037 118.726.423.629-.276.724-.327-.069-.066-1.269z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__t)",
  d: "m10.193 119.381.3.476-.101.464-.31.172-.258-.586.054-.321z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__u)",
  d: "m10.865 120.261.265.321-.1.584-.207.19-.259-.156-.118-.579z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__v)",
  d: "m9.521 120.882.386.166.003.377-.31.086-.207-.224z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__w)",
  d: "m8.694 121.037.231-.162.21.205-.155.397-.293.063-.104-.132v-.018z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__x)",
  d: "m8.694 122.021.352-.163.21.291.068.173-.396.357-.19-.133-.034-.173z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__y)",
  d: "m8.143 122.4.248.045.089.222v.171l.052.255-.396.005-.121-.483z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__z)",
  d: "m7.747 123.09.386.235.244.532-.052.12-.017.203-.465-.03-.108-.48-.22-.244z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__A)",
  d: "m6.197 120.641.646.317.001.203-.896-.064.017-.276z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__B)",
  d: "m6.576 121.469.15.249-.127.294.202.309-.32.448-.205-.003.034-.593-.241-.248.275-.276z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__C)",
  d: "m6.507 124.539.752.094.2.243-.262.326-.819.241-.602-.021-.12-.196.55-.455z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__D)",
  d: "m6.955 123.849.23.044.27.257.008.189-.481-.055-.207-.231z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__E)",
  d: "m5.577 123.09.15.025.062.329-.228.43.128.292-.43-.003-.069-.61z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__F)",
  d: "m3.561 119.64.63.61.58.107.255.428.335.145.052.415.397.484-.293.859-.7.113-.44-.487-.267-.027-.229.396.4.303-.336.795.084.137.33.009.202-.132.645.348.003.266-.135.304.238.246-.041.302-.393.271-.099-.418-.254.048-.184-.42-.553-.395-.487.108-.067-.418-.189-.239-.377-.039-.225-.253-.065-.486-.386-.444-.263.004-.212-.048-.11.382-.298.017-.219-.489.118-.517-.211-.227.131-.346.765-.326.347.11.372-.057.297-.38.33.21-.09.592.244.062.209-.239-.077-.175-.002-.245-.182-.312-.569-.082.5-.655z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__G)",
  d: "m9.521 125.954.16.112.306.154-.082.136-.07.217-.235-.007-.208.326-.515-.383.103-.299z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__H)",
  d: "m37.062 124.476-.09-.154-.089-.099.191-.164h.275l.121.054.229.014-.098.18-.13.142z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__I)",
  d: "m38.073 124.736-.001-.376.243-.215.079.697-.25.039z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__J)",
  d: "m38.71 124.132-.018-.703.191-.061.084.45.222.264-.008.308-.06.065-.004.145-.203.212-.185-.156z"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__K)",
  d: "m40.089 124.58.05-.254.228-.063.135-.118.272.213.1.208-.255.264-.512-.07z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__L)",
  d: "m41.57 123.735.517-.263.1.437-.362.075z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__M)",
  d: "m42.293 123.235.083-.277.28-.004.185.42-.241.127-.262-.152z"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__N)",
  d: "m43.74 122.631.169-.225.62.313-.017.282-.607-.101z"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__O)",
  d: "m45.67 122.821.375-.312.24.382-.137.231-.262-.153z"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__P)",
  d: "m44.498 122.269.427-.45.31.003.086.316-.52.4z"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__Q)",
  d: "m48.202 123.597.183-.18.088.007.235.22.127.093-.293.178-.348-.015z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__R)",
  d: "m47.582 121.579.288.103v.933l-.24.006-.211-.498z"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__S)",
  d: "m14.3 104.968.195.056.393.719-.187.208-.399-.001-.276-.293.205-.208z"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__T)",
  d: "m12.088 118.467.509.767v.397h-.345l-.208-.277-.1-.768z"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__U)",
  d: "m12.966 118.57.44.457.019.067.274.261-.172.517-.275-.06-.468-.596.005-.493z"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__V)",
  d: "m12.398 117.466.268.198.034.604-.275.276-.364-.38-.047-.424z"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__W)",
  d: "m13.53 127.756.39.018.053.187-.308.204-.242.193-.31-.158z"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__X)",
  d: "m14.752 126.255.235.225.003.531-.12.17-.345-.03-.137-.4.191-.218z"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__Y)",
  d: "m11.726 120.141.196.389-.17.377-.292-.224.054-.407z"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__Z)",
  d: "m12.363 120.934.248.355-.083.153-.362.035-.172-.225.106-.286z"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__aa)",
  d: "m13.035 120.399.079.56-.128.043-.114.181-.172-.241.054-.511z"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ab)",
  d: "m14.43 120.158.079.266-.232.323-.103.186-.268.009-.086-.087.002-.32z"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ac)",
  d: "m12.208 122.676.231.269.709-.019-.018.286-.041.31-.227.075-.248.105-.792-.276.123-.718z"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ad)",
  d: "m14.327 123.401.007.286-.072.307-.022.236-.094.155-.248.172-.52.023-.23-.291.31-.311.04-.078.41-.467z"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ae)",
  d: "m13.138 122.159-.042.404-.24.277-.218-.049-.18-.124.131-.131.025-.093.226-.235z"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__af)",
  d: "m13.827 122.193.43.886-.454.243-.225-.172.02-.821z"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ag)",
  d: "m15.963 120.261.044.215.68.971-.079.357-.03.346-.29.288-.382-.064.023-.258.078-.426-.37-.304-.319-.72.07-.501.174-.148z"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ah)",
  d: "m15.567 123.349.403.286-.175.255-.453.116-.376.551-.313-.115.096-.668.104-.417z"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ai)",
  d: "m15.136 121.365.044.249.027.22-.405.091-.362-.328.044-.237.113-.17z"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__aj)",
  d: "m16.418 124.532-.077.215-.965-.012-.127-.219.38-.366z"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ak)",
  d: "m17.055 123.549-.214.525-.603.075-.007-.409.603-.331z"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__al)",
  d: "m19.374 121.866.199.318-1.378 1.577-.378.032-.268-.303.065-.362-.443-.128-.096-.368.298-.568.477.12.416-.045z"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__am)",
  d: "m18.967 123.86-.33.476-.056-.026-.227.265h-.308l-.19-.202.528-.633.362-.021z"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__an)",
  d: "m22.044 123.211-.611.853.342.774-.61.657.01.387-.24.336-.5.077-.62-.252-.398.251-.613-.037-.324-.49.116-.569.677-.524-.045-.265-.236-.292.236-.208.003-.235.17-.17.362.253z"
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ao)",
  d: "m20.239 127.027-.142.198-.57-.114-.206-.444.182-.15.431.066z"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ap)",
  d: "m18.844 126.837-.056.25-.449-.011-.086-.426.167-.153.034-.019.136-.116.276.169z"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__aq)",
  d: "m19.395 127.976-.487.342-.466-.202.51-.53.466.032z"
})), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__ar)",
  d: "m22.134 125.388-.349.06-.087-.178.303-.306.276.101z"
})), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__as)",
  d: "m21.445 126.388-.16-.462.389-.323.327.497-.252.149z"
})), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__at)",
  d: "m24.958 128.476-.22-.059-.164-.111.217-.254.293.061.38-.099-.133.305-.175.046z"
})), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#finland_map_svg__au)",
  d: "m28.093 127.527-.332-.17.217-.392.277-.164h.257l.126.071.224-.002-.416.357z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__a",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__b",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__c",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__d",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__e",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__f",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__g",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__h",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__i",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__j",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__k",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__l",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__m",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__n",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__o",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__p",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__q",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__r",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__s",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__t",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__u",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__v",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__w",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__x",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__y",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__z",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__A",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__B",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__C",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__D",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__E",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__F",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__G",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__H",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__I",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__J",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__K",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__L",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__M",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__N",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__O",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__P",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__Q",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__R",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__S",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__T",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__U",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__V",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__W",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__X",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__Y",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__Z",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__aa",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ab",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ac",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ad",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ae",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__af",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ag",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ah",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ai",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__aj",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ak",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__al",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__am",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__an",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ao",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ap",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__aq",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__ar",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__as",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__at",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "finland_map_svg__au",
  x1: 37.25,
  x2: 37.25,
  y1: 0.956,
  y2: 128.956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75739C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403F58"
})))));
export default SvgFinlandMap;